var React = require('react');

function StatusExpected (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"d":"M0 0h23v23H0z"})),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":1},[React.createElement("g",{"key":0},[React.createElement("mask",{"fill":"#fff","key":0},React.createElement("use",{"xlinkHref":"#a"})),React.createElement("path",{"d":"M11.5 0C5.16 0 0 5.16 0 11.5 0 17.843 5.16 23 11.5 23S23 17.843 23 11.5C23 5.16 17.84 0 11.5 0","fill":"#47CCCD","mask":"url(#b)","key":1})]),React.createElement("path",{"d":"M10.615 6.514l-.001 4.102H6.513a.885.885 0 0 0 0 1.77h4.1v4.1a.885.885 0 0 0 1.77 0v-4.1l4.102-.002a.882.882 0 0 0 .884-.884.885.885 0 0 0-.884-.885l-4.102.001V6.514a.885.885 0 0 0-1.768 0z","fill":"#FFF","key":1})])]);
}

StatusExpected.defaultProps = {"viewBox":"0 0 23 23"};

module.exports = StatusExpected;

StatusExpected.default = StatusExpected;
